const ANCHOR_OFFSET = 100

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

function scrollToAnchor(hash, behavior) {
  if (!hash || hash.length <= 1) return false

  const target = document.getElementById(decodeURIComponent(hash.slice(1)))
  if (!target) return false

  const top = target.getBoundingClientRect().top + window.scrollY - ANCHOR_OFFSET

  window.scrollTo({
    top,
    behavior: behavior ?? (prefersReducedMotion() ? 'auto' : 'smooth')
  })

  return true
}

function handleAnchorClick(event) {
  const link = event.target.closest('a[href^="#"]')
  if (!link) return
  if (link.matches('[class*="js-modal-open"]')) return

  const hash = link.getAttribute('href')
  if (!hash || hash === '#') return

  const target = document.getElementById(decodeURIComponent(hash.slice(1)))
  if (!target || target.classList.contains('modal')) return
  if (!scrollToAnchor(hash)) return

  event.preventDefault()

  if (history.pushState) {
    history.pushState(null, '', hash)
  } else {
    window.location.hash = hash
  }
}

function initAnchorScroll() {
  document.addEventListener('click', handleAnchorClick)

  if (window.location.hash) {
    requestAnimationFrame(() => {
      scrollToAnchor(window.location.hash, prefersReducedMotion() ? 'auto' : 'smooth')
    })
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAnchorScroll)
} else {
  initAnchorScroll()
}
